import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Button, FormField, Input } from '@/components';
import { AuthLayout } from '@/components/layout/AuthLayout';
import { useForgotPassword } from '@/hooks/useAuth';

type FormValues = {
  email: string;
};

export function ForgotPassword() {
  const navigate = useNavigate();
  const { register, handleSubmit, formState } = useForm<FormValues>({
    defaultValues: { email: '' },
  });

  const forgot = useForgotPassword();

  const onSubmit = handleSubmit(async (values) => {
    try {
      await forgot.mutateAsync(values);
      toast.success('Se o email existir, enviamos um link para redefinir a senha.');
      navigate('/login');
    } catch (e) {
      toast.error('Não foi possível processar sua solicitação.');
    }
  });

  return (
    <AuthLayout>
      <div className="auth-header">
        <h1>Recuperar senha</h1>
        <p>Você receberá um link para redefinir a senha.</p>
      </div>

      <form onSubmit={onSubmit} className="auth-form">
        <FormField label="Email" error={formState.errors.email?.message}>
          <Input type="email" autoComplete="email" {...register('email', { required: 'Informe seu email' })} />
        </FormField>

        <div className="auth-actions">
          <Button type="submit" variant="primary" disabled={forgot.isLoading}>
            Enviar link
          </Button>
          <button type="button" className="link" onClick={() => navigate('/login')}>
            Voltar
          </button>
        </div>
      </form>
    </AuthLayout>
  );
}
